/** @format */

import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RendererService {
  private renderer: Renderer2;

  /**
   * Set the DOM renderer so it can be used outside the component tree.
   * @param renderer
   */
  setRenderer(renderer: Renderer2) {
    this.renderer = renderer;
  }

  /**
   * Get the DOM renderer outside the component tree.
   * @returns
   */
  getRenderer() {
    return this.renderer;
  }
}
